export default "__VITE_PUBLIC_ASSET__f5562905__"